// Generated by scripts/update-seeq-icons.js from src/svg/seeq/eraser.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcEraser = {
  prefix: 'fak',
  iconName: 'eraser' as IconName,
  icon: [
    1189,
    1024,
    [],
    'e95e',
    'M843.5 879.3l294.2-300.9c29.5-30.3 47.6-71.6 47.7-117.3 0-46.9-19.2-89.4-50.3-119.9l0 0-298.3-293.5c-30.4-30.4-72.4-49.1-118.8-49.1-47.7 0-90.7 19.8-121.3 51.7l-0.1 0-548.9 562.4c-29.5 30.3-47.6 71.6-47.6 117.3 0 46.9 19.2 89.4 50.2 119.8l0 0.1 177.5 173.7h961.4v-144.3zM128.7 770.1c-10.1-10.2-16.4-24.2-16.4-39.8s6.3-29.5 16.4-39.7l0 0 274-280.4 380.4 372.9-95.8 98.1h-447.5z',
  ],
} satisfies IconDefinition;
